import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { ManualTaskListItemContentProps } from 'Automations/nodeDefinitions/types'
import { IntegrationSyncErrorIcon } from './IntegrationSyncErrorIcon'
import {
  syncErrorDescription,
  syncErrorTitle
} from './integrationSyncErrorMessages'
import { SyncErrorTaskInput } from './types'

export const IntegrationSyncErrorListItem = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: ManualTaskListItemContentProps) => {
  const { manualTask, isUnread, statusIcon } =
    useManualTaskListItemContentToolkit<SyncErrorTaskInput>({ taskId })

  const input = manualTask?.input

  if (!manualTask || !input) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      title={syncErrorTitle(input)}
      description={syncErrorDescription(input)}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <IntegrationSyncErrorIcon externalService={input.externalService} />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
